import { MerchantAppReturnZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

export const getReturn = {
  name: "getReturn" as const,
  input: z.object({
    returnId: z.string(),
    locale: z.string().max(35).optional(),
  }),
  output: z.object({ data: MerchantAppReturnZodSchema }),
};
